import { LOANREQUEST_BUCKETS, SYSTEM_BUCKET_DISTRIBUTION, SYSTEM_VARIABLE_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaSystemVariableCommon } from './systemVariableCommon';

export const schemaBuckets = z
    .object({
        property: z.record(
            z.nativeEnum(LOANREQUEST_BUCKETS),
            z.object({
                distribution: z.nativeEnum(SYSTEM_BUCKET_DISTRIBUTION),
            }),
        ),
        type: z.literal(SYSTEM_VARIABLE_TYPES.BUCKETS),
    })
    .merge(schemaSystemVariableCommon);
